import React from 'react';
import PropTypes from 'prop-types';
import QuickQuote from 'components/QuickQuote';
import { QuickQuoteProvider } from 'contexts/QuickQuoteContext';
import parse from 'html-react-parser';

const HeroSectionWithQuickQuote = ({
  header, subheader, quickQuoteTitle, couponCode, breakText, buttonText, allowedLocations
}) => {

  return (
    <div className="relative px-7 py-14 pt-16 md:py-12 md:px-16 lg:py-[104px] lg:px-[88px] xl:px-44 2xl:px-60">
      <div className="
        flex flex-col gap-11 lg:gap-28 lg:flex-row justify-between
        items-center max-w-100 mx-auto text-center lg:text-left
      ">
        <div className="lg:w-1/2">
          <h1 className="
            text-[2.5rem] lg:text-[3rem] leading-[3.125rem] lg:leading-[3.875rem]
            text-white font-bold mb-6 break-words
          ">
            {parse(header || 'Ship Your Luggage with CLEAR')}
          </h1>
          <p className="font-semibold text-white text-lg mb-7">
            {parse(subheader || 'Sign up to receive exclusive offers and updates from CLEAR.')}
          </p>
        </div>
        <QuickQuoteProvider allowedLocations={allowedLocations}>
          <QuickQuote
            className="md:w-10/12 lg:w-1/2"
            title={quickQuoteTitle}
            couponCode={couponCode}
            breakText={breakText}
            buttonText={buttonText}
          />
        </QuickQuoteProvider>
      </div>
    </div>
  );
};

HeroSectionWithQuickQuote.propTypes = {
  header: PropTypes.string,
  subheader: PropTypes.string,
  quickQuoteTitle: PropTypes.string,
  couponCode: PropTypes.string,
  breakText: PropTypes.string,
  buttonText: PropTypes.string,
  allowedLocations: PropTypes.array,
};

export default HeroSectionWithQuickQuote;
